import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const flashSaleAddEditRBAC = {
  pageID: '9638cae57acf22b89f1da93ab6e5f758',
  elementID: {
    ViewFlashSale: 'bcf9f38c373916f34f5b4c9ddfe6ff4e',
    SaveFlashSale: '21e3f6ad74c2e23048f000ad604e35a1',
  },
} as const

export const useRBACFlashSaleAddEditPage = createUseRBAC(flashSaleAddEditRBAC.elementID)

export type UseRBACFlashSaleAddEditPageType = ReturnType<typeof useRBACFlashSaleAddEditPage>
